import "../../assets/css/community-progress.css";
import Image from "../Image/Image";
import Panel from "../Panel/PanelShimmer";
import { CommunityProgressMenu } from "./CommunityProgressMenu";

export function CommunityProgressPhaseThree(props) {
  const {loading, handleOnChange, communityPhase} = props;

  return (
    <Panel classList="community-progress__panel" shimmerProps={{height: "400px", classList: 'community-progress__panel', testId: 'community-progress'}}
    showShimmer={loading}>
        <h3 className="eta">Community Progress</h3>
        <p>Your child's community is in Phase {communityPhase}.</p>
        <CommunityProgressMenu selectedPhase={3} handleOnChange={handleOnChange} />
        <p className="community-progress__phase-title">Phase 3: Empower</p>
        <p>
          Local leaders and families take on more ownership and self-sufficiency grows. The community and children grow stronger and healthier thanks to large improvements in areas like clean water, education, nutrition, and more.
          <Image 
          src='https://wvusstatic.com/community-phases/spinning-world-phase3.gif' 
        />
        </p>
     </Panel>
    );
  }

  
export default CommunityProgressPhaseThree;